<template>
	<!-- 全局下拉选 -->
	<div class="select-wrap">
		<p class="name">
			{{ name }}
		</p>
		<select @change="selectChange" :class="state.set.color==0?'grey':'aaa'">
			<option v-for="(item, index) in options" :key="index" :value="item.id" :selected="item.selected">
        {{ $t(item.txt) }}</option>
		</select>
	</div>
</template>

<script setup>
	import {
		getCurrentInstance,
		onMounted,
		reactive,
		ref
	} from "vue";

	const emit = defineEmits();
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	import {
		useRouter
	} from 'vue-router';
	const router = useRouter();
	// 多语言调用
	const {
		appContext: {
			config: {
				globalProperties
			}
		}
	} = getCurrentInstance();
	const props = defineProps({
		name: String,
		options: Array,
		modelValue: Number
	})
	const state = reactive({
		set: {
			color: 0,
		},
	})


	function selectChange(event) {
		state.set.color = event.target.value
		emit("update:modelValue", event.target.value);
		if (event.target.value == 1) {
			store.dispatch('asyncUpdateAlertInfo', {
				isShow: true,
				title: globalProperties.$t('专属与真号'),
				content: globalProperties.$t('本号码是付费功能,是否创建专属与真号？'),
				isChancelShow: true,
				callback: () => router.push("/exclusiveMeetingCode"),
				cancelCallback: () => console.log('取消回调')
			})
		}
	}

	onMounted(() => {
		// props.options.forEach(item => {
		// 	item.txt = globalProperties.$t(item.txt)
		// })
	})
</script>

<style scoped>
	::v-deep.el-textarea__inner {
		font-size: 0.83333vw;
		padding-left: 1.25vw;
	}

	.select-wrap {
		width: 30.20833vw;
		margin: 0 auto;
	}

	.select-wrap .name {
		font-size: 0.9375vw;
		line-height: 1.30208vw;
		font-weight: bold;
		color: #2F3367;
		margin-bottom: 0.41666vw;
	}

	.select-wrap select {
		display: block;
		width: 100%;
		font-size: 0.83333vw;
		line-height: 1.14583vw;
		box-sizing: border-box;
		border: 0.05208vw solid #D4D6D8;
		border-radius: 0.20833vw;
		padding: 0.72916vw 1.25vw;
		background: url("../../assets/img/icons/icon-arr-down.png") no-repeat;
		background-size: 1.14583vw 1.04166vw;
		background-position: right 1.25vw center;
		transition: border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);
		color: #2F3367;
	}

	.select-wrap select.grey {
		color: #8B8FA8 !important;
	}

	.select-wrap select:hover {
		border-color: #aaaeb7;
	}

	@media screen and (max-width: 750px) {

		.select-wrap {
			width: 82.93333vw;
		}

		.select-wrap .name {
			font-size: 3.73333vw;
			line-height: 5.33333vw;
			margin-bottom: 1.6vw;
		}

		.select-wrap select {
			font-size: 3.73333vw;
			line-height: 5.33333vw;
			padding: 2.66666vw 3.2vw;
			background-size: 4.26666vw;
			border-radius: 0.53333vw;
			border-width: 0.13333vw;
		}

	}
</style>
